
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  serviceBaseURL: string = environment.serviceBaseUrl;

  filesArray: any[];

  constructor(private http: HttpClient) { }

  ImageUpload(fileList: FileList, folderName: string) {
    let promise = new Promise((resolve, reject) => {
      if (fileList.length > 0) {
        this.filesArray = Array.from(fileList);
        this.upload(this.filesArray.pop(), folderName).then(() => {
          resolve();
        });
      }
    });
    return promise;
  }

  upload(file: File, folderName: string) {
    let promise = new Promise((resolve, reject) => {
      //let file: File = fileList[i];
      let formData: FormData = new FormData();
      formData.append('uploadImageFile', file, file.name);
      let headers = new HttpHeaders()
      headers.append('Content-Type', 'multipart/form-data');
      headers.append('Accept', 'application/json');
      let apiUrl = this.serviceBaseURL + "Kesavi/ImageUpload?folderName=" + folderName;

      const options = {
        headers: headers //new HttpHeaders().append('Content-Type', 'json').append('Accept', 'application/json')
      }
      this.http.post(apiUrl, formData, options).toPromise().then((res) => {
        if (this.filesArray.length > 0) {
          this.upload(this.filesArray.pop(), folderName).then(() => {
            resolve();
          });
        }
        else {
          resolve();
        }
      }).catch((err) => {
        console.log(err);
        reject();
      });
    });
    return promise;
  }


}